<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <pr-input-radio
      formControlName="investmentDurationViager"
      columns="3"
      [toggle]="true"
      [isDefault]="false"
      label=""
    >
    </pr-input-radio>
    @if (form.get('investmentDurationViager')?.value == false) {
      <pr-input-column
        label="Vous fixez la durée à "
        [derrors]="derrors"
        [isDefault]="false"
        [suffix]="'années'"
      >
        <input formControlName="investmentDurationYear" type="text" />
      </pr-input-column>
    }
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
